import React from 'react';
import { ModelList } from '../../../fasades/modellist';
import { IModel } from '../../api/llmapi';
import { Util } from '../../../fasades/util';
import { IoClose } from "react-icons/io5";
import { IoMdAdd } from "react-icons/io";
import { LuSettings2 } from "react-icons/lu";
import { MdDeleteForever } from "react-icons/md";
import { RoundButton } from "../roundbutton";
import './modellist.css';

type ModelListProps = {
    onExit?      : () => void;
};

type ModelListState = {
    dropdownOpen : boolean;
    models       : IModel[];
    selected     : IModel | undefined;
};

export class ModelListComp extends React.Component<ModelListProps, ModelListState> 
{
    state: ModelListState = {
        dropdownOpen : false,
        models       : ModelList.getModelList(),
        selected     : ModelList.selectedModel
    };

    constructor(props: {}) {
        super(props);
        this.handleUpdate = this.handleUpdate.bind(this);
    }

    componentDidMount()
    {
        ModelList.onUpdate(this.handleUpdate);
        ModelList.loadModels();
    }

    componentWillUnmount()
    {
        ModelList.removeUpdateEvent(this.handleUpdate);
    }

    onDelete(model : IModel) {
        ModelList.deleteModel(model);
    }

    onExit() {
        if (this.props.onExit !== undefined) {
            this.props.onExit();
        }
    }

    async selectModel(model : IModel)
    {
        this.setState({ dropdownOpen : false });
        ModelList.selectModel(model);
    };

    handleUpdate(list : IModel[], selected? : IModel)
    {
        this.setState({ models: list, selected : selected });
    }

    toggleDropdown()
    {
        this.setState(prev => ({ dropdownOpen: !prev.dropdownOpen }));
    }

    render() {
        return (
            <div className="model">
                <div className="model-header">
                    <h1>Models</h1>
                    <div className="model-header-actions">
                        <RoundButton
                            description={false}
                            name="New Model"  
                            onClick={ () => ModelList.createModel() }
                            icon = { IoMdAdd }/>
                        <RoundButton
                            description = { false }
                            icon = {IoClose}
                            name="Back to conversation"
                            onClick={ () => this.onExit() }/>

                    </div>
                </div>
                { this.renderList() }
            </div>
        );
    }

    renderList() : React.JSX.Element
    {
        let list = [];
        let i    = 0;

        for (const model of this.state.models) {
            const active = model.id === this.state.selected?.id;

            list.push(
                <li key={model.name + i}
                    className={`model-entry${active ? ' active' : ''}`}
                    onClick={() => this.selectModel(model)}>
                    <div >
                        <div className="modellist-name">{model.name}</div>
                        <div className="modellist-desc">{model.description}</div>
                        <div className="modellist-time">{Util.formatRelativeTime(new Date(model.last_modified)) }</div>
                    </div>
                    <div className="model-actions">
                        { !model.read_only &&
                        <button title="Delete" onClick={(e) => {
                                e.stopPropagation();
                                this.onDelete(model);
                            }}>
                            {React.createElement(MdDeleteForever as React.ComponentType)}
                        </button>
                        }
                        { active && 
                        <button title="Edit" onClick={(e) => {
                                e.stopPropagation();
                                ModelList.editModel();
                            }}>
                            {React.createElement(LuSettings2 as React.ComponentType)}
                        </button>
                        }

                    </div>
                </li>);
            i++;
        }

        return <ul className="model-list">{list}</ul>;
    }
}

